export default new class CategoryNav {
    constructor() {
        this.categoryNav = '.fs-category-nav';

        if (!document.querySelector(this.categoryNav)) return;

        this.categoryNavBtn = '.fs-category-nav--btn';
        this.categoryNavLink = '.fs-category-nav--link';

        this.classOpen = 'fs--open';
        this.classSubNav = 'fs--sub-nav';

        this.eventsHandler();
    }

    eventsHandler() {
        document.querySelectorAll(this.categoryNavLink).forEach(link => {
            link.addEventListener('click', this.toggleSubMenu);
        })
    }

    toggleSubMenu = e => {
        const link = e.target;

        if (link.classList.contains(this.classSubNav)) {
            e.preventDefault();
            link.classList.toggle(this.classOpen);
        }
    }
}